module.exports = __webpack_public_path__ + "img/qjxd_banner_en.a4513581.png";